import { Theme } from '@heidi/schema/ml-scribe';
import { type ThemeProvider } from 'next-themes';
import { type ComponentProps } from 'react';

type ThemeProviderConfig = Pick<
  ComponentProps<typeof ThemeProvider>,
  | 'attribute'
  | 'defaultTheme'
  | 'themes'
  | 'disableTransitionOnChange'
  | 'enableSystem'
  | 'value'
>;

export const themeProviderConfig: ThemeProviderConfig = {
  attribute: 'class',
  defaultTheme: Theme.newBrand,
  themes: ['light', 'dark', Theme.newBrand, Theme.newBrandDark],
  disableTransitionOnChange: true,
  enableSystem: true,
  value: {
    light: Theme.newBrand,
    dark: Theme.newBrandDark,
    [Theme.newBrand]: Theme.newBrand,
    [Theme.newBrandDark]: Theme.newBrandDark,
  },
};
